// extracted by mini-css-extract-plugin
export var cardHeader = "_fm-0";
export var reorderHandle = "_fm-3";
export var titleArea = "_fm-1";
export var titleAreaWithHandle = "_fm-2";